import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';


//Components Material
import AppBar from "@material-ui/core/AppBar";
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import { Button, Modal } from "@material-ui/core";
import TrashAlt from '../../assets/svgs/solid/trash-alt';

import { currentScrollingPage, itemPerPage } from "../../constants/index";


//Actions
import { getAllhelpTiles, gethelpTileById, delHelp_Tile } from '../../actions/helpTileAction';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';


//Modals
import ModalHelpTile from './ModalHelpTile';

import { ADD_HELP_TILES_SUCCESS, DEL_HELP_TILES_SUCCESS } from '../../constants/helpTilesConstants';


export class HelpTiles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            helpTileSelected: null,
            tableData: [],
            currentPage: currentScrollingPage,
            itemPerPage: itemPerPage
        };
        this.observer = React.createRef();
        this.lastHelpTileRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));
                    this.getHelpTiles();
                }
            });
            if (node) this.observer.current.observe(node)
        }
    };

    componentDidMount() {
        document.title='Help Info'

        this.getHelpTiles();
        this.SetHeaderButtons();
    };


    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = () => {
        return (
            <div className='appbtn-list-engage globalActions'>
                <Grid item container xs={12} className='appbtn-list-engage globalActions' justify='flex-end' alignItems='center'>
                    <Grid item
                        id='Add_HelpTile_Btn'
                        className="blueBottomButon appbtnBarButton"
                        onClick={this.handlerAdd} >
                        Add Help Tile
                    </Grid>
                </Grid>
            </div>
        );
    };

    editHelpTile = (e, item) => {
        this.setState({ open: true, helpTileSelected: item })
    }

    handlerAdd = () => {
        this.setState({ open: true, helpTileSelected: null });
    };

    getHelpTiles = () => {
        this.props.getAllhelpTiles(this.state.currentPage);
    };

    handleDeleteClick = async (e, data, index) => {
        if (e) {
            e.stopPropagation();
        }

        this.props.delHelp_Tile(data._id)
    };

    ThumbnailImage = (
        {
            height = '70px',
            width = '110px',
            alt,
            url
        }
    ) => {
        return (
            <img
                alt={'Thumbnail ' + alt}
                style={{ borderRadius: '10px', alignContent: 'center', objectFit: 'cover' }}
                width={width}
                height={height}
                src={url}
            >
            </img>
        );
    };


    OnCancelDelete = () => {
        this.setState({ open: false })

    }
    OnDeleteHandler = () => {
        this.setState({ open: false, currentPage: 0 });
    }
    OnAddHandler = () => {
        this.setState({ open: false, currentPage: 0 });
    }

    render() {

        if (this.props.helpTileReducerType === DEL_HELP_TILES_SUCCESS || this.props.helpTileReducerType === ADD_HELP_TILES_SUCCESS) {
            this.getHelpTiles();
        }

        const currentData = this.props.tableData ? this.props.tableData.data : [];
        const totalTiles = this.props.tableData ? this.props.tableData.totalHeplTiles : 0;
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    <Toolbar >
                        <Grid container >
                            <Grid item container xs={!this.state.open ? 4 : 12} sm={6} md={6} lg={6} alignContent='center' justify='flex-start'>

                                <Typography variant="h6"  >
                                    <div id='HelpTiles_back_btn' className="engage-nav ToolbalCommunityName" onClick={this.handlerCancel}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                            alt='return'
                                            className="returnIcon"
                                        />
                                        Help Tiles
                                    </div>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <main className="content-engage-dining" style={{ paddingTop: '15px' }}>
                    <div>
                        <>
                            <Grid container className="activityTitle-engage">

                                <Grid container className="titleEngageStyleList">
                                    <Grid item xs={12} id='dining_title'><p>Help Tiles ({totalTiles})</p></Grid>
                                </Grid>

                                <Grid container className="titleActivityStyleHeaders" style={{ display: displayHeaders }} justify='center' alignItems='center' >
                                    <Grid item md={1} style={{ textAlign: 'center' }} >Image</Grid>
                                    <Grid item md={3}>
                                        Title
                                    </Grid>
                                    <Grid item md={5}>
                                        Description
                                    </Grid>
                                    <Grid item md={2}>
                                        Group
                                    </Grid>
                                    <Grid item md={1}></Grid>
                                </Grid>
                                <Grid container>
                                    {currentData && currentData.map((item, index) => {
                                        /* We call the reference in the last row */
                                        return (
                                            <Grid ref={currentData.length === index + 1 ? this.lastHelpTileRef : undefined} container key={index}
                                                justify='center' alignItems='center' className="rowEngageStyleList"
                                                id={`dining_row_${item._id}`}
                                                onClick={(e) => {
                                                    this.editHelpTile(e, item);
                                                }}>
                                                <Grid item xs={12} sm={12} md={1} style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', }}>
                                                    <this.ThumbnailImage alt={index} url={item.thumbnailURL ? item.thumbnailURL : ''} />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={3} className="rowEngageStyle rowEngageStyleLeft" >{item.title}</Grid>
                                                <Grid item xs={12} sm={12} md={5} className="rowEngageStyle rowEngageStyleLeft" >{item.description}</Grid>
                                                <Grid item xs={12} sm={12} md={2} className="rowEngageStyle rowEngageStyleLeft" >{item.group}</Grid>
                                                <Grid item xs={12} sm={12} md={1} className='EngageButonClass' style={{ alignContent: 'flex-end', display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button
                                                        id={`delete_btn_dining_row_${item._id}`}
                                                        variant="text"
                                                        value={item._id}
                                                        color='secondary'
                                                        className="transparentButtom"
                                                        onClick={(e) => {
                                                            this.handleDeleteClick(e, item);
                                                        }}
                                                    >
                                                        <TrashAlt className="iconDeleteListIcon" />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    )}

                                </Grid>
                            </Grid>
                            {
                                this.state.open ?
                                    <Modal
                                        open={this.state.open}
                                        onClose={this.CancelDelete}
                                        aria-labelledby="simple-modal-title"
                                        aria-describedby="simple-modal-description"
                                        style={{ borderRadius: '16px' }}
                                    >
                                        <ModalHelpTile
                                            helpTile={this.state.helpTileSelected ? this.state.helpTileSelected : null}
                                            OnCancelHandler={this.OnCancelDelete}
                                            OnAddHandler={this.OnAddHandler}
                                            OnDeleteHandler={this.OnDeleteHandler}
                                        />
                                    </Modal> : undefined
                            }
                        </>
                    </div>
                </main>
            </React.Fragment>
        );
    }
};


function mapStateToProps(state) {
    let helpTileData = (state.helpTileReducer && state.helpTileReducer.helpTileData) ? state.helpTileReducer.helpTileData : [];

    return {
        tableData: helpTileData,
        helpTileReducerType: (state.helpTileReducer && state.helpTileReducer.type) ? state.helpTileReducer.type : "",
    }
};

export default connect(mapStateToProps, { getAllhelpTiles, gethelpTileById, SetHeaderButtons, delHelp_Tile })
    (reduxForm({
        form: 'HelpTilesForm',
        enableReinitialize: true,
    })(HelpTiles));
